export type User = {
    id: number;
    username: string;
    email: string;
    description: string;
    hobby: string;
    gender: string;
    age: number;
    education: string;
};

export function newUser(userID = -1, name = "", email = ""): User {
    const newUser: User = {
        id: userID,
        username: name,
        email: email,
        description: "",
        age: -1,
        gender: "",
        education: "",
        hobby: "",
    };

    return newUser;
}
